import Nullstack from 'nullstack';
export default function IconHierarchyOff({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-hierarchy-off",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("circle", {
    cx: "12",
    cy: "5",
    r: "2"
  }), "   ", Nullstack.element("circle", {
    cx: "5",
    cy: "19",
    r: "2"
  }), "   ", Nullstack.element("path", {
    d: "M17.585 17.587a2 2 0 0 0 2.813 2.843"
  }), "   ", Nullstack.element("path", {
    d: "M6.5 17.5l5.5 -4.5l5.5 4.5"
  }), "   ", Nullstack.element("path", {
    d: "M12 7v1m0 4v1"
  }), "   ", Nullstack.element("path", {
    d: "M3 3l18 18"
  }), " ");
}